<template>
    <LoadingSpinner v-if="loading" />
    <div v-else class="mid">
        <template v-if="submitError">
            <h1 class="mb-3">{{ $t('assessmentSubmitFailedTitle') }}</h1>
            <div class="bg-white rounded p-4 d-flex flex-column align-items-center justify-content-center text-center mb-3">
                <p class="mb-0">{{ $t('assessmentSubmitFailedText') }}</p>
            </div>
            <b-button class="p-3 mt-2" block variant="primary" @click="$emit('retry')">{{ $t('submit') }}</b-button>
        </template>
        <template v-else-if="submitted">
            <svg-icon class="complete mx-auto" icon="completedCircle" />
            <h1 v-if="expired">{{ $t('timeExpired') }}</h1>
            <h1 v-else class="mb-3">{{ $t('assessmentCompleted') }}</h1>
            <div class="bg-white rounded p-4 d-flex flex-column align-items-center justify-content-center text-center mb-3">
                <div :class="textDir" v-if="outro" v-html="outro"></div>
                <div v-else><p>{{ $t('thankYouAssessment') }}</p></div>
            </div>
            <b-button class="p-3 mt-2" block variant="primary" @click="$emit('finish')">{{ $t('finish') }}</b-button>
        </template>
    </div>
</template>
<script>
import LoadingSpinner from '@/components/loader/Loader.vue';
import SvgIcon from '@/components/SvgIcon';
export default {
    name: "AssessmentOutro",
    components: {
        SvgIcon,
        LoadingSpinner
    },
    props: {
        outro: String,
        expired: Boolean,
        loading: Boolean,
        submitted: Boolean,
        submitError: Boolean,
        textDir: {
            type: String,
            default: ''
        }
    },
    mounted() {
        window.onbeforeunload = () => {
            return true;
        };
    }
}

</script>
